export default __webpack_public_path__ + "static/media/calories.e9d3133e.svg";